import RbacHelpers from 'RBAC/rbac.helpers';
import { NavItemProps } from './constants/NavItem.interface';
import { ILinks } from './constants/routes.interface';

/**
 * Iterates the links and filters out any links that the user
 * does not have permission to OR does not have the feature flag = true
 * @param links
 * @returns TabItemProps[]
 */
export const getLinks = (links: ILinks[], permissions: any): NavItemProps[] => {
  return links.reduce((acc: NavItemProps[], item) => {
    const hasPermission = RbacHelpers.checkPermissions(permissions, item.permissionRef);
    if (hasPermission && item.featureFlag) {
      return [...acc, item.tabItem];
    } else {
      return acc;
    }
  }, []);
};
